const SET_SELECTED_DEPOT = "SET_SELECTED_DEPOT";

export const actionTypes = {
  SET_SELECTED_DEPOT,
};

export const setSelectedDepot = (depotCode) => ({
  type: SET_SELECTED_DEPOT,
  payload: depotCode,
});
